// extracted by mini-css-extract-plugin
module.exports = {"task_section":"styles_task_section__2EZ-K","btn_accent_width":"styles_btn_accent_width__1XWfm"};